import { UserSettings } from "./UserSettings";

export default class UserSettingsResponse {
  learningAutoAdjustLevel: boolean;
  isAutoPronunciation: boolean;

  constructor(learningAutoAdjustLevel: boolean, isAutoPronunciation: boolean) {
    this.learningAutoAdjustLevel = learningAutoAdjustLevel;
    this.isAutoPronunciation = isAutoPronunciation;
  }

  static fromJson(json: any): UserSettingsResponse {
    let learningAutoAdjustLevel = json.learningAutoAdjustLevel ?? false;
    let isAutoPronunciation = json.isAutoPronunciation ?? false;
    return new UserSettingsResponse(
      learningAutoAdjustLevel,
      isAutoPronunciation
    );
  }

  toEntity(): UserSettings {
    return new UserSettings(
      this.learningAutoAdjustLevel,
      this.isAutoPronunciation
    );
  }
}
